import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const EliminarInformeConservacion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/EliminarInformeConservacion",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { EliminarInformeConservacion };
